import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  InputSignal,
  Signal,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import type { HashMap } from "@ngneat/transloco";
import { TranslateService } from "@services";
import { type BadgeStatus, StatusBadgeComponent } from "../status-badge/status-badge.component";
import type { ChallengeStatus } from "../../model";

const STATUS_MAP: Record<ChallengeStatus, BadgeStatus> = {
  PASSED: "success",
  ACTIVE: "warning",
  BREACHED: "danger",
  BLOCKED: "danger",
  PROVISIONING: "provisioning",
};

@Component({
  selector: "app-challenge-status",
  standalone: true,
  imports: [StatusBadgeComponent],
  templateUrl: "./challenge-status.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./challenge-status.component.scss"],
})
export class ChallengeStatusComponent {
  public readonly status: InputSignal<ChallengeStatus> = input.required<ChallengeStatus>();

  public readonly badgeStatus: Signal<BadgeStatus> = computed(
    (): BadgeStatus => STATUS_MAP[this.status()],
  );

  public readonly label: Signal<string> = computed(
    (): string => (this._labels()?.[this.status()] as string | undefined) ?? "",
  );

  private readonly _translateService: TranslateService = inject(TranslateService);

  private readonly _labels: Signal<HashMap | undefined> = toSignal(
    this._translateService.selectTranslationObject("shared.challengeStatus"),
  );
}
